/* eslint-disable no-console */
import { Socket } from 'phoenix';
let socket;
let channel;
if (window.currentUser) {
    socket = new Socket('/socket', {
        params: {
            token: window.currentUser.token,
            locale: window.locale
        }
    });
    socket.connect();
    channel = socket.channel(`user:${window.currentUser.id}`, { token: window.currentUser.token });
    channel
        .join()
        .receive('ok', resp => {
        console.log('Joined successfully', resp);
    })
        .receive('error', resp => {
        console.log('Unable to join', resp);
    });
    window.socket = socket;
}
else {
    console.log('User not signed in, not connecting user socket');
}
export default channel;
